// extracted by mini-css-extract-plugin
export var anchor = "_54-0";
export var discard = "_54-4";
export var muiTooltipTooltip = "_54-6";
export var notificationBar = "_54-3";
export var saveButtonHoverSlotWrapper = "_54-5";
export var show = "_54-2";
export var spacer = "_54-1";